export default "__VITE_ASSET__BhPfZJrc__"